import { Moment } from 'moment';

export enum WaitlistStatus {
  PENDING = 'Pending',
  APPROVED = 'Approved',
  REJECTED = 'Rejected'
}

export interface RawWaitlistData {
  id: string;
  email: string;
  status: WaitlistStatus;
  created_at: string;
}

export interface WaitlistData {
  id: string;
  email: string;
  status: WaitlistStatus;
  createdAt: Moment | null;
}
